<script lang="ts" setup>
    import { onMounted, reactive } from 'vue';

    import Icon from '../../components/Icon.vue'
    import Tab from "../../components/Tab.vue"

    import { ICol, ValueStrDelegate } from "../../lib/ChoiceTableHelpers";
    import { ccdaBuilder } from '../../lib/ChoiceApi';
    import { CCDABuildLocation, CCDABuildStatus } from "../../Enums/ChoiceEnums";
    import { LayoutOrientation, MessageSectionType, DisplayStyle, IconTypes } from "../../Enums/UiEnums";
    import { ICCDACaseSummaryResponseItem } from '../../lib/Models/CCDAModel';
    import { CCDViewer } from '../../lib/OfficeMdUrls';

    const props = defineProps<{
        responseList?: ICCDACaseSummaryResponseItem[]
    }>();

    const formData = reactive <
    {    
        tabIndex: number
    }>({ 
        tabIndex: 0
    });

    onMounted(async () => {
        console.log(props.responseList);
    });
</script>

<style>
    .caseReportResponseLabelWidth {
        width: 170px;
        color: #003366;
        font-size: 12px;
        font-weight: bold;
        font-family: Verdana, Tahoma, sans-serif;
    }
    .caseReportResponseLabelValue {
        font-size: 12px;
        font-family: Verdana, Tahoma, sans-serif;
    }
</style>

<template>
    <div class="row">
        <div class="col">
            <template v-for="(item,index) in props.responseList">
                <Tab :value="index" v-model="formData.tabIndex" :layout="LayoutOrientation.Horz">                    
                    Response #{{ index+1 }}
                </Tab>
            </template>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-auto">
            <template v-for="(item,index) in props.responseList">
                <template v-if="formData.tabIndex == index">
                    <div class="row mt-2">
                        <div class="caseReportResponseLabelWidth">
                            Patient Name
                        </div>
                        <div class="col ps-0 caseReportResponseLabelValue">
                            {{ item.patientFirstName }} {{ item.patientLastName }}
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="caseReportResponseLabelWidth">
                            Report Type
                        </div>
                        <div class="col ps-0 caseReportResponseLabelValue">
                            {{ item.reportType }}
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="caseReportResponseLabelWidth">
                            Report Timeframe
                        </div>
                        <div class="col ps-0 caseReportResponseLabelValue">
                            {{ item.reportTimeFrame }}
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="caseReportResponseLabelWidth">
                            Jurisdiction
                        </div>
                        <div class="col ps-0 caseReportResponseLabelValue">
                            {{ item.jurisdiction }}
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="caseReportResponseLabelWidth">
                            Effective Time
                        </div>
                        <div class="col ps-0 caseReportResponseLabelValue">
                            {{ item.effectiveTime }}
                        </div>
                    </div>
                    <div v-if="item.isReportError" class="row mt-2">
                        <div class="col-auto">
                            <Icon :icon="IconTypes.CircleXMark" title="An error has occurred" :displayStyle="DisplayStyle.Danger"/>
                        </div>
                        <div class="col border border-danger">
                            There was a problem with the Case Report<br>Please contact support.
                        </div>
                    </div>
                </template>
            </template>
        </div>
        <div class="col">
            <template v-for="(item,index) in props.responseList">
                <template v-if="formData.tabIndex == index">
                    <iframe
                        :src="`/officemd/app/ccd/casereportviewer/0/${item.directAttachmentId}`"
                        width="100%"
                        height="600"
                        style="border: none;"
                        title="Case Report Response"
                    ></iframe>                
                </template>
            </template>
        </div>
    </div>
</template>

